import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase/client';

export const StatusProcessContext = createContext();

export const useStatusProcess = () => {
    const context = useContext(StatusProcessContext);
    if (!context) {
        throw new Error('useStatusProcess debe estar dentro del proveedor StatusProcessContext')
    }
    return context;
};

export const StatusProcessContextProvider = ({ children }) => {
    const [statusProcess, setStatusProcess] = useState([])
    const [modal, setModal] = useState(false)

    const getModal = () => {
        setModal(false)
    }

    const getStatus = async () => {
        const { error, data } = await supabase
            .from('status_process')
            .select('id, name')
            .order('name', { ascending: true })
        if (error) throw (error.message)
        setStatusProcess(data)
    }

    const getStatusId = async (id) => {
        const { error, data } = await supabase
            .from('status_process')
            .select('id, name')
            .eq('id', id)
            .single()
        if (error) throw (error.message)
        return data
    }

    return (
        <StatusProcessContext.Provider value={{
            statusProcess,
            modal,
            getStatus,
            getStatusId,
            // createSpecialty,
            // updateSpecialty,
            getModal
        }}>
            {children}
        </StatusProcessContext.Provider>
    )
}